import {
  CreateIssueSubtypeRequestDto,
  IssueSubtypeDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateIssueSubtype() {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    IssueSubtypeDto,
    ExtendedAxiosError,
    CreateIssueSubtypeRequestDto
  >({
    mutationKey: ['issue-subtypes'],
    mutationFn: (data) =>
      api.issueSubtypesApi.createIssueSubtype(data).then((r) => r.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', 'roles'],
      });
    },
  });
}
